export default __webpack_public_path__ + "static/media/projectsIcon.11793d61.svg";